import { render } from "./EventDetailComponent.vue?vue&type=template&id=e316b64c&scoped=true&ts=true"
import script from "./EventDetailComponent.vue?vue&type=script&lang=ts"
export * from "./EventDetailComponent.vue?vue&type=script&lang=ts"

import "./EventDetailComponent.vue?vue&type=style&index=0&id=e316b64c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e316b64c"]])

export default __exports__